import { render, staticRenderFns } from "./CanceledDeparturesConfirm.vue?vue&type=template&id=77eda4d8&scoped=true"
import script from "./CanceledDeparturesConfirm.vue?vue&type=script&lang=js"
export * from "./CanceledDeparturesConfirm.vue?vue&type=script&lang=js"
import style0 from "./CanceledDeparturesConfirm.vue?vue&type=style&index=0&id=77eda4d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77eda4d8",
  null
  
)

export default component.exports